import type { QueryClient, UseQueryResult } from '@tanstack/react-query'
import * as OrderKeys from '../reactQueryKeys/orders'

export type OfferTypeForTripItemTypes =
  | App.Offer
  | App.OfferSummary
  | App.Tours.TourV2Offer
  | App.Tours.TourV2OfferSummary
  | App.BedbankOffer
  | App.BedbankOfferSummary
  | App.CruiseOffer
  | App.ExperienceOffer

// To make multi-query results a bit nicer to work with. Add new fields as needed.
export type MultiQueryResults<T> = {
  data: Array<T>
  isLoading: boolean
  isSuccess: boolean
  results: Array<UseQueryResult<T>>
}

export const MINUTES = 60 * 1000
export const NON_TRIP_STALE_TIME = 4 * MINUTES
export function removeAuthedQueries(queryClient: QueryClient) {
  queryClient.removeQueries(OrderKeys.all)
}
